export default __webpack_public_path__ + "static/media/facialemotion.c407abfe.jpg";